import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
// For New Frontend System
// import { ApiBlueprint } from '@backstage/frontend-plugin-api';
import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),

  // For New Frontend System
  // ApiBlueprint.make({
  //   name: 'scm-integrations',
  //   params: defineParams =>
  //     defineParams({
  //       api: scmIntegrationsApiRef,
  //       deps: { configApi: configApiRef },
  //       factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  //     }),
  // }),
  // ApiBlueprint.make({
  //   name: 'scm-auth',
  //   params: defineParams => defineParams(ScmAuth.createDefaultApiFactory()),
  // }),
];
